import React, { FC, useMemo } from 'react';

import { useFormikContext } from 'formik';

import Divider from 'components/shared/Divider';
import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import useRevokeEntityPermission from 'hooks/entity-permissions/useRevokeEntityPermission';
import { useAuthSession } from 'hooks/useAuthSession';

import { EntityType } from 'models/entity-permission.model';
import { EntityPermissionUsers } from 'models/user.model';

import { EntityPermissionUserFormikContext, UserGroup } from './constant';

interface GroupUsersListProps {
    formulaId: number;
    hasWriteAccess: boolean;
}
const GroupUsersList: FC<GroupUsersListProps> = ({
    formulaId,
    hasWriteAccess,
}) => {
    const { user: signedInUser } = useAuthSession();

    const { values, resetForm } =
        useFormikContext<EntityPermissionUserFormikContext>();
    const revokePermissionMutation = useRevokeEntityPermission(
        EntityType.formula,
        formulaId.toString(),
    );
    const users = useMemo<EntityPermissionUsers[]>(() => {
        if (values.selectedGroup) {
            return values.groups[values.selectedGroup];
        }
        return [];
    }, [values]);

    const handleRevoke = (userId: number) => {
        revokePermissionMutation.mutate(
            {
                entity_id: formulaId.toString(),
                entity_type: EntityType.formula,
                user_ids: [userId],
            },
            {
                onSuccess: () => {
                    resetForm();
                },
            },
        );
    };

    return (
        <Container>
            {users.map((user, index) => (
                <>
                    <ListItem>
                        <Text>{user.username}</Text>
                        {hasWriteAccess &&
                            values.selectedGroup == UserGroup.editors &&
                            Number(signedInUser?.id) !== user.id && (
                                <ActionText
                                    onClick={() => handleRevoke(user.id)}
                                >
                                    Revoke Access
                                </ActionText>
                            )}
                    </ListItem>
                    {index != users.length - 1 && <Divider />}
                </>
            ))}
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
});

const ListItem = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.medium,
});

const Text = styled.span({
    color: aampeTheme.colors.black,
});

const ActionText = styled.span({
    color: aampeTheme.colors.textAccessibleWG01,
    cursor: 'pointer',
});

export default GroupUsersList;
